(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-swatch"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
    var toggle = event.target.closest('[data-swatch-toggle]');
    if (!toggle) return;

    var container = toggle.closest('.swatches_container');
    if (!container) return;

    var hiddenSwatches = container.querySelectorAll('.swatch--extra');
    var isExpanded = toggle.getAttribute('aria-expanded') === 'true';

    hiddenSwatches.forEach(function(swatch) {
      swatch.classList.toggle('swatch--hidden', isExpanded);
    });

    toggle.setAttribute('aria-expanded', String(!isExpanded));

    if (isExpanded) {
      var totalWithSwatch = hiddenSwatches.length + container.querySelectorAll('.swatch:not(.swatch--extra)').length;
      var maxVisible = totalWithSwatch - hiddenSwatches.length;
      var extraCount = totalWithSwatch - maxVisible;
      toggle.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M5.34944 3.88805H9.47744V5.13605H5.34944V9.26405H4.10144V5.13605H-0.00256243V3.88805H4.10144V4.64916e-05H5.34944V3.88805Z" fill="currentcolor"/></svg>' + "<span></span>" +extraCount;
    } else {
      toggle.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="9" height="2" viewBox="0 0 9 2" fill="none"><path d="M8.11456 -1.50204e-05V1.24799H0.00256252V-1.50204e-05H8.11456Z" fill="currentcolor"/></svg>';
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["onutricia-centred-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{
  document.querySelectorAll('.on-centred-menu details[open]').forEach(details=>{
    if(!details.contains(event.target))details.open=false;
  });
});
document.addEventListener('keydown',event=>{
  if(event.key!=='Escape')return;
  const nav=event.target.closest('.on-centred-menu');
  if(!nav)return;
  const open=event.target.closest('details[open]');
  if(open){open.open=false;open.querySelector('summary').focus();}
});
  } catch(e) { console.error(e); }
})();

})();
